/**
 * @generated SignedSource<<cbd7383fea06c8eca5c5f3d69f6856bc>>
 * @relayHash e5de3a9b6facebd1568f0561d8175770
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fe1635716f814f40c4fea09db4afcccabd7b69f511bd75ebd62f991a8851389f

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type inProductInviterNotificationMutation$variables = {
  cloudId: string;
  isEnabled: boolean;
};
export type inProductInviterNotificationMutation$data = {
  readonly jira: {
    readonly updateGlobalNotificationPreferences: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly preferences: {
        readonly " $fragmentSpreads": FragmentRefs<"inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type inProductInviterNotificationMutation = {
  response: inProductInviterNotificationMutation$data;
  variables: inProductInviterNotificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "items": [
          {
            "fields": [
              {
                "kind": "Literal",
                "name": "channel",
                "value": "IN_PRODUCT"
              },
              {
                "kind": "Variable",
                "name": "isEnabled",
                "variableName": "isEnabled"
              },
              {
                "kind": "Literal",
                "name": "type",
                "value": "PROJECT_INVITER_NOTIFICATION"
              }
            ],
            "kind": "ObjectValue",
            "name": "preferences.0"
          }
        ],
        "kind": "ListValue",
        "name": "preferences"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "inProductInviterNotificationMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "inProductInviterNotificationMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "projectInviterNotification",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "concreteType": "JiraNotificationChannel",
                        "kind": "LinkedField",
                        "name": "inProductChannel",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fe1635716f814f40c4fea09db4afcccabd7b69f511bd75ebd62f991a8851389f",
    "metadata": {},
    "name": "inProductInviterNotificationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ef75a99451e568681ca1ab673b52975e";

export default node;
